export default {
  name: "activityListing",
  api: {
    endpoints: {
      tabCounts: "/1.0/getactabcount",
      listView: "/1.0/getactgvdbu",
      cardView: "/1.0/getactcvdbu",
      listViewSearch: "/1.0/getactgvdbus",
      cardViewSearch: "/1.0/getactcvdbus",
      bulkActionHandler: "/vldunassactcntapi",
      bulkAccept: "/1.0/blkaccactapi",
      bulkReject: "/1.0/blkrejactapi",
      acceptReassignData: "/1.0/blkreassusrs",
      bulkAcceptReassign: "/1.0/blkaccreaasactapi",
    },
  },
  params: {
    listView: {
      search: "key",
      skip: "skip",
      take: "take",
      rows: "rows",
      page: "page",
      status: "status",
      sortBy: "sortBy",
      sortDir: "sortDir",
      isSearch: "isSearch",
    },
    cardView: {
      search: "key",
      skip: "skip",
      take: "take",
      rows: "rows",
      page: "page",
      status: "status",
      sortBy: "sortBy",
      sortDir: "sortDir",
      isSearch: "isSearch",
    },
  },
};
